module.exports = __webpack_public_path__ + "static/media/received_836569123346457 - SamRaisbeck.cd211e61.jpeg";